import { render, staticRenderFns } from "./census.vue?vue&type=template&id=04e78a8f&scoped=true"
import script from "./census.vue?vue&type=script&lang=js"
export * from "./census.vue?vue&type=script&lang=js"
import style0 from "./census.vue?vue&type=style&index=0&id=04e78a8f&prod&lang=scss&scoped=true"
import style1 from "./census.vue?vue&type=style&index=1&id=04e78a8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e78a8f",
  null
  
)

export default component.exports